import {ProcessStageTitle} from '@hconnect/common/components/shiftEventLabels'
import {useProcessStages} from '@hconnect/common/hooks/useProcessStages'
import React from 'react'

type EventProcessStageTitleProps = {
  plantId: string
  stage?: string
}

export const EventProcessStageTitle = ({plantId, stage}: EventProcessStageTitleProps) => {
  const stages = useProcessStages(plantId).data
  return <ProcessStageTitle stages={stages} stage={stage} />
}
